import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import {
    Breadcrumb,
    BreadcrumbLink,
    StandardBreadcrumbs,
} from "../../../../../shared/components/links/StandardBreadcrumbs"
import { PageHeader } from "../../../../../shared/components/pageHeader/PageHeader"
import { Page } from "../../../../../shared/components/pageHeader/PageHeaderApi"
import { MERCHANT_REPORTS_ROUTE } from "../../../../../constants/routes"

import { PosTransactionsTable, ProductionOrderTypeFilter } from "./components/PosTransactionsTable"

export function PosPurchases() {
    return (
        <>
            <LocalizedStrict id="production-pos-purchases-page-header" attrs={{ title: true }}>
                <PageHeader page={Page.PRODUCTION_POS_PURCHASES} title="POS purchases">
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="merchant-nav-item-home">
                            <BreadcrumbLink to={MERCHANT_REPORTS_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="merchant-production">
                            <Breadcrumb>Production</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="production-pos-purchases-breadcrumb">
                            <Breadcrumb>POS purchases</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <PosTransactionsTable defaultOrderType={ProductionOrderTypeFilter.LUNCH} />
        </>
    )
}
